import React, { useState } from "react";
//import RowCard from "../../../components/RowCard";
import Atestado from "../../../components/Atestado";
import ModalComponent from "../../../components/Modal";
import CardAtestado from "./components/CardAtestado";

const ContAtestado = ({interacao, atestado, paciente, usuario}) => {

    const [ itemAtestado, setItemAtestado ] = useState(null);
    const [ visibleModal, setVisibleModal ] = useState(false);

    const openModal = (item) => {
        setVisibleModal(true);
        setItemAtestado(item);
    }

    return(
      <>
        <div className="p-2">
        {atestado
            ?
            atestado.map((item, index) => {
            return (
                <div className="row">
                    <div className="col-sm-12">
                        <CardAtestado
                            idAtestado={item.id}
                            card={"atestado"}
                            interacao={interacao}
                            paciente={paciente}
                            pacienteId={paciente.id}
                            profissional={item.profissional.nome}
                            Hora={item.atestado.Hora ? item.atestado.Hora: null}
                            DataAtendimento={item.atestado.DataAtendimento}
                            DataCriacao={item.atestado.DataCriacao}
                            Dia={item.atestado.Dia}
                            OpenModal={() => openModal(item)}
                        />
                    </div>
                </div>
            );
            })
            : null}
        </div>
        <ModalComponent
            style={{ zIndex: 99999 }}
            openModal={visibleModal}
            closeModal={() => setVisibleModal(false)}>
            <Atestado
                item={itemAtestado}
                usuario={usuario}
                idPaciente={paciente.id}
                dataAtendimento={null}
                //this.state.dataAtendimento
            />
        </ModalComponent>
    </>)
}

export default ContAtestado;